import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Icon from "@mui/material/Icon";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import toast from "utils/toast";

const copyToClipboard = (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    return navigator.clipboard.writeText(text);
  }
  // Fallback for non-HTTPS environments where the Clipboard API is unavailable
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  const ok = document.execCommand("copy");
  document.body.removeChild(textarea);
  return ok ? Promise.resolve() : Promise.reject(new Error("Copy failed"));
};

function CopyLinkDialog({ open, title, message, link, copyLabel, successMessage, onClose }) {
  const handleCopy = () => {
    copyToClipboard(link)
      .then(() => {
        toast.success(successMessage);
        onClose();
      })
      .catch(() => toast.error("Failed to copy link."));
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ pb: 1 }}>
        <MDTypography variant="h6" fontWeight="medium">{title}</MDTypography>
      </DialogTitle>
      <DialogContent>
        <MDTypography variant="body2" color="text" sx={{ mb: 2 }}>
          {message}
        </MDTypography>
        <TextField
          fullWidth
          size="small"
          value={link}
          InputProps={{ readOnly: true }}
          onFocus={(e) => e.target.select()}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5 }}>
        <MDButton variant="outlined" color="secondary" onClick={onClose}>
          Cancel
        </MDButton>
        <MDButton variant="gradient" color="info" onClick={handleCopy} disabled={!link}>
          <Icon sx={{ mr: 0.5 }} fontSize="small">content_copy</Icon>
          {copyLabel}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

CopyLinkDialog.defaultProps = {
  message: "",
  copyLabel: "Copy Link",
  successMessage: "Link copied!",
};

CopyLinkDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  link: PropTypes.string.isRequired,
  copyLabel: PropTypes.string,
  successMessage: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default CopyLinkDialog;
